import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, ImageAvatar, SquareChip, TagsArray, Text, useSettings } from 'app/main/components';
import { DateRangeSquareChip } from 'app/main/components/list-items';
import buttons from './MarketingActionsButtons';

export default function MarketingActionsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.maac_user_assigned_uid}
			avatar={props.model.user_assigned_avatar}
			initials={props.model.maac_title_initials}
			labelBadge={props.model.mast_title_initials}
			labelBadgeTooltip={props.model.mast_title}
			badgeColor={props.model.mast_color}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 600 ? 8 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.maac_warning_desc && (
								<Tooltip title={props.model.maac_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.maac_blocked_desc && (
								<Tooltip title={props.model.maac_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'marketingactions', uid: props.model.maac_uid }}
							>
								{props.model.maac_title}
							</Text>
						</Grid>
						{/* TYPE */}
						<Grid>
							{props.model.maty_title && (
								<SquareChip label={props.model.maty_title} backgroundColor={props.model.maty_color} />
							)}
						</Grid>
						{/* DATE FROM - TO */}
						<Grid>
							<DateRangeSquareChip from={props.model.maac_d_from} to={props.model.maac_d_to} />
						</Grid>
						{/* TAGS */}
						<Grid>
							<TagsArray tags={props.model.maac_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={4}>
						<Grid container>
							{/* INTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.maac_user_assigned_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_INTUSER')}
								>
									{props.model.user_assigned_title}
								</ButtonLink>
							</Grid>
							{/* EXTERNAL ASSIGNED USER */}
							<Grid size={12}>
								<ButtonLink
									href={`/users/details/${props.model.maac_user_assigned_2_uid}`}
									icon="account-circle"
									fallback={t('VIEW_ITEM_NO_EXTUSER')}
								>
									{props.model.user_assigned_2_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
